import './ScrollBox.scss';

export default function ScrollBox({
  widthbox,
  children,
}) {
  return (
    <div
      data-testid="scroll-box"
      className="scroll-box"
      style={widthbox ? { width: widthbox } : undefined}
      role="region"
    >
      <div className="STUDENT">
        {children}
      </div>
    </div>
  );
}